export const Role = {
    ManageUsers: 'ACCOUNTUSERS',
    ManageSettings: 'ACCOUNTSETTINGS',
}